<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-04-22 18:23:22
-->
<template>
    <div>
        <el-container class="baimo-scrollbar bm bm-no-seleted" :style="{height: container_height+'px'}">
            <el-aside :style="{ width: leftWidth + 'px' }" class="bm-aside" style="overflow: hidden;">
                <div class="information" style="padding: 0px;">
                    <el-tabs type="border-card">
                        <el-tab-pane label="Main">
                    <el-scrollbar :style="{height: mainHeight, background:'white'}">

                            <ProteinSelector v-on:proteinAccession="getProteinAccession" v-on:sourceDB="getsourceDB"
                                v-on:valuePDB="getvaluePDB"></ProteinSelector>
                            <raac-selector></raac-selector>
                            <SelectedRegion :selectedHeight="selectedHeight"></SelectedRegion>
                            </el-scrollbar>
                        </el-tab-pane>
                        <el-tab-pane label="Structure">
                            <StructureSetting></StructureSetting>
                        </el-tab-pane>
                        <el-tab-pane label="Sequence">
                            <SequenceSetting></SequenceSetting>
                        </el-tab-pane>
                    </el-tabs>
                    
                </div>
            </el-aside>
            <BaimocXHandle @leftWidthChange="getLeftWidthChange" />

            <el-main style="padding: 0px;overflow: hidden;">
                <ProteinStructureView :height="structrueHeight + 'px'" width="100%"></ProteinStructureView>
                <BaimocYHandle @heightChange="heightChange" />
                <ProteinSequenceView :height="totalHeight - structrueHeight - 120 + 'px'" :width="yhandleWidth + 'px'">
                </ProteinSequenceView>
            </el-main>
            <BaimocRXHandle @rightWidthChange="getRightWidthChange" />
            <el-aside :width="rightWidth + 'px'"
                style=" display: blank;padding: 0px;background-color: #ffffff; border-left: 1px solid #cccccc;overflow: hidden;z-index:666">
                <!--<div style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8">-->
                <!--<p style="padding: 5px 0px 0px 5px; font-weight: 900">Information</p>-->
                <!--</div>-->
                <div class="information">
                    <el-tabs type="border-card" v-model="current_tab">
                        <el-tab-pane label="Main">
                            <ProteinAnalysisMain></ProteinAnalysisMain>
                        </el-tab-pane>
                        <el-tab-pane  v-if="current_db === 'AlphaFold'" label="Model">
                            <AlphaFold></AlphaFold>
                        </el-tab-pane>
                        <el-tab-pane label="Protein">
                            <protein></protein>
                        </el-tab-pane>
                        <el-tab-pane label="Raac">
                            <raac></raac>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-aside>
        </el-container>
        <baimo-footer :accession="accession"></baimo-footer>
    </div>
</template>

<script>
    import ProteinStructureView from "../../components/structure/ProteinStructureView.vue";
    import ProteinSequenceView from "../../components/sequence/ProteinSequenceView.vue";
    import RaacSelector from "../../components/selector/RaacSelector";
    import SelectedRegion from "../../components/selector/SelectedRegion.vue";
    import ProteinSelector from "../../components/selector/ProteinSelector";
    import ProteinAnalysisMain from "../../components/information/ProteinAnalysisMain.vue";
    import Protein from "../../components/information/Protein";
    import Raac from "../../components/information/Raac";
    // import ThreeSelector from "../../components/selector/ThreeSelector"
    import BaimocYHandle from "../../components/BaimocYHandle";
    import BaimocXHandle from "../../components/BaimocXHandle";
    import BaimocRXHandle from "../../components/BaimocRXHandle";
    import StructureSetting from "../../components/laside/StructureSetting";
    import SequenceSetting from "../../components/laside/SequenceSetting";
    import AlphaFold from "../../components/information/AlphaFold.vue";
    import BaimoFooter from "../../components/BaimoFooter";

    import global_ from "../../components/units/Global";
    import axios from "axios";

    export default {
        name: "ExpBrowser",
        data() {
            return {
                website: global_.website,
                source: global_.source,
                selectedHeight: window.innerHeight - 540 + "px",
                mainHeight: window.innerHeight - 90 + "px",
                container_height: window.innerHeight - 70,
                structrueHeight: window.innerHeight - 355 - 40,
                totalHeight: window.innerHeight - 13,
                winHeight: window.innerHeight - 52 + "px",
                winWidth: window.innerWidth - 50 + "px",
                leftWidth: 320,
                rightWidth: 360,
                yhandleWidth: window.innerWidth - 360 - 360,
                loading: true,
                dialogTableVisible: false,
                accession: "Q01860",
                jobid: "",
                selected_id: "",
                source_db: "AlphaFold",
                value_pdb: "",
                current_protein:{},
                current_db: '',
                current_tab: "0",
                updated_time: "",
            };
        },
        watch: {
            '$store.state.current_protein'(res, res1) {
                // console.log("$store.state.current_protein>>>", res)
                // if (res['accession'] !== res1['accession'] || this.is_init) {
                //     this.current_protein = res;
                    
                // }
                // if (res['source_db'] !== res1['source_db']) {
                //     this.current_protein = res;
                //     this.current_db = this.current_protein['source_db']
                // }
                this.current_db = res["source_db"];
                if(this.current_db === "AlphaFold"){
                    if (res["accession"] !== res1["accession"] || this.is_init) {
                        this.current_protein = res;
                        this.current_tab = "0";
                    }
                }else{
                    if (res["pdb_id"] !== res["pdb_id"] || this.is_init) {
                        this.current_protein = res;
                        this.current_tab = "0";
                    }
                }
            },
        },
        components: {
            ProteinStructureView,
            BaimocYHandle,
            ProteinSequenceView,
            RaacSelector,
            ProteinSelector,
            ProteinAnalysisMain,
            Protein,
            Raac,
            BaimocXHandle,
            BaimocRXHandle,
            StructureSetting,
            AlphaFold,
            BaimoFooter,
            SequenceSetting,
            SelectedRegion,
        },
        mounted() {
            this.jobid = this.$route.params.jobid;
            this.$store.commit("sequenceMenuMutation", {
                color: [""],
                focus: false,
                leftWidth: this.leftWidth,
                multi: false,
                representation: [""],
            });
            this.$store.commit("structureResizeMutation", this.structrueHeight);
            if(this.$store.state.current_tool !== "ProteinFold"){
                this.$store.commit("raacSchemeMutation", ['KR','ANCQGHILMFPQSTVWY','DE']);
                this.$store.commit("raacColorMutation", ['#E77F67', '#546DE5', '#546DE5']);
            }
            this.$store.commit("currentToolMutation", "ProteinFold");
            this.getProteinAccession(this.accession);
            this.current_db = this.$store.state.current_protein['source_db'];
            
        },
        methods: {
            getvaluePDB(val) {
                this.value_pdb = val
                // console.log("value_pdb", this.value_pdb)
                let url = `https://www.ebi.ac.uk/pdbe/api/mappings/uniprot/${this.value_pdb}`;
                // console.log("url>>>>", url)
                // console.log("this.accession", this.accession)
                axios.get(url).then((res) => {
                    // let pdb_id = this.value_pdb.toLowerCase();
                    // console.log("res>>>", res)
                    // console.log(res.data)
                    // console.log(pdb_id)
                    // console.log(res.data[pdb_id])
                    // console.log(res.data[this.value_pdb.toLowerCase()]['UniProt'])
                    let mappings = res.data[this.value_pdb.toLowerCase()]['UniProt'][this.accession]['mappings'][0];

                    // for(let key in res.data){
                    //     console.log("============")
                    //     console.log(key)
                    //     console.log(pdb_id)
                    //     console.log(key === pdb_id)
                    // }

                    // console.log(mappings)
                    let chain = mappings['chain_id'];
                    let start = mappings['unp_start'];
                    let end = mappings['unp_end'];
                    switch (this.value_pdb) {
                        case "6YOV":
                            start = 141;
                            end = 208;
                            break;
                        case "6T90":
                            start = 138;
                            end = 210;
                            break;
                    }

                    this.getProteinSource(chain, start, end)
                });
            },
            getProteinSource(chain, start, end) {
                chain,
                start,
                end
                let url = `https://www.ebi.ac.uk/proteins/api/proteins/${this.accession}`;
                // console.log("url>>>>", url)
                // console.log("pdb_start>>>>", start)
                // console.log("this.accession", this.accession)
                // console.log("this.source_db", this.source_db)
                axios.get(url).then((res) => {
                    // console.log("res>>>", res)
                    let sequence = res.data['sequence']['sequence'];
                    let cut_sequence = sequence.substring(start - 1, end)
                    let cut_seq_len = cut_sequence.length;
                    let seq_len = sequence.length;
                    let coverage = cut_seq_len * 100 / seq_len;
                    // let pdb_url = `https://ftp.wwpdb.org/pub/pdb/data/structures/divided/mmCIF/kx/${this.value_pdb}.cif.gz`;
                    let pdb_url = `https://files.rcsb.org/download/${this.value_pdb}.pdb.gz`;
                    // console.log("sequence", sequence)
                    // console.log("cut_sequence", cut_sequence)
                    // console.log("cut_sequence", coverage.toFixed(3))
                    // console.log("pdb_url", pdb_url)
                    this.$store.commit("currentProteinMutation", {
                        source_db: this.source_db,
                        accession: this.accession,
                        description: "",
                        info: sequence,
                        natural: sequence,
                        natural_seq: sequence,
                        pdb_id: this.value_pdb,
                        pdb_chain: chain,
                        pdb_seq: cut_sequence,
                        pdb_start: start - 1,
                        score: [],
                        pdb_url: pdb_url,
                    });

                });
            },
            getsourceDB(val) {
                this.source_db = val
                // console.log("this.source_db", this.source_db)
                if (val === "AlphaFold") {
                    this.$store.commit("currentProteinMutation", {
                        source_db: "AlphaFold",
                        accession: "Q01860",
                        description: "POU domain, class 5, transcription factor 1",
                        info: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        natural: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        natural_seq: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        score: "54.92|42.51|53.65|44.79|54.12|47.54|43.20|45.72|46.36|49.61|48.97|52.59|58.06|65.44|53.55|42.57|49.62|41.15|50.56|46.22|54.73|44.09|37.23|44.42|50.59|47.12|54.21|44.68|42.07|47.23|40.75|47.46|52.14|52.17|46.81|49.45|41.85|41.92|42.87|42.12|62.14|53.10|42.59|46.25|49.30|48.29|48.66|44.30|43.81|48.34|48.21|44.15|43.97|39.18|44.36|41.53|43.13|44.18|36.37|44.41|50.43|55.05|36.95|48.00|54.03|48.40|40.25|36.44|33.00|42.28|35.56|34.10|44.44|37.13|44.07|42.70|38.45|40.19|44.58|44.80|37.36|46.36|33.27|41.35|43.75|38.69|47.90|38.74|39.95|41.78|36.39|38.09|35.64|39.32|48.30|34.47|41.38|41.10|40.08|37.37|44.13|41.56|48.48|41.32|52.27|40.66|47.81|46.13|41.52|46.13|42.97|47.34|42.43|40.32|38.53|31.95|43.35|41.83|45.12|36.39|36.14|47.69|38.95|43.13|39.76|38.63|38.94|36.19|41.11|40.47|48.12|53.05|68.50|69.81|76.65|79.89|84.08|91.23|91.82|92.98|94.97|94.49|95.20|96.25|97.09|97.69|97.96|98.06|98.46|98.50|98.14|97.66|98.21|98.22|97.60|95.53|95.96|96.05|94.59|92.19|92.37|92.70|94.69|95.62|92.69|92.58|93.88|93.15|89.85|89.94|91.56|88.83|85.96|85.77|86.70|85.90|86.15|90.55|92.67|93.05|94.55|96.94|97.52|97.61|98.22|98.46|98.53|98.42|98.19|97.74|97.92|96.88|96.71|96.32|95.71|96.64|97.69|96.87|95.81|96.38|96.81|95.69|94.79|96.95|96.14|93.39|94.67|94.88|93.12|90.53|89.35|85.30|82.13|71.15|67.03|70.21|74.01|68.22|67.50|68.24|64.61|63.06|60.92|57.66|56.54|56.42|60.05|60.99|55.47|60.28|63.59|64.27|73.57|82.31|87.01|89.05|89.77|93.34|93.11|94.23|95.43|94.95|95.25|95.90|96.79|96.43|96.07|95.07|95.98|94.11|93.97|90.96|94.07|94.89|95.60|96.53|95.92|96.27|96.69|97.28|97.41|96.97|96.74|96.86|96.48|95.61|94.89|94.34|95.15|95.21|96.65|96.07|96.49|97.32|97.60|96.76|97.08|97.48|95.36|96.11|95.32|95.16|91.29|89.15|83.82|79.35|72.03|67.92|58.08|54.17|53.05|46.86|51.88|47.30|49.35|50.16|46.97|47.20|45.23|49.35|46.65|37.29|44.26|41.65|46.38|41.82|43.93|46.93|43.67|54.80|47.01|55.78|47.27|43.87|51.27|48.17|55.25|51.85|41.29|50.72|40.72|41.51|53.40|40.67|49.67|48.08|37.77|50.79|43.61|43.15|37.90|41.65|47.62|35.96|41.70|39.37|48.52|46.48|43.95|62.32|42.66|44.50|41.64|41.82|51.87|65.49|51.35|52.91|48.77|41.20|46.73|44.91|56.42|50.03|56.64|57.18|61.27|57.52|56.13|55.02",
                        pdb_url: this.source + "/AF-Q01860-F1-model_v1.pdb",
                        updated_time: new Date().toString(),
                    });
                } else {
                    this.$store.commit("currentProteinMutation", {
                        source_db: "PDB",
                        accession: "Q01860",
                        description: "",
                        info: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        natural: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        natural_seq: "MAGHLASDFAFSPPPGGGGDGPGGPEPGWVDPRTWLSFQGPPGGPGIGPGVGPGSEVWGIPPCPPPYEFCGGMAYCGPQVGVGLVPQGGLETSQPEGEAGVGVESNSDGASPEPCTVTPGAVKLEKEKLEQNPEESQDIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEEADNNENLQEICKAETLVQARKRKRTSIENRVRGNLENLFLQCPKPTLQQISHIAQQLGLEKDVVRVWFCNRRQKGKRSSSDYAQREDFEAAGSPFSGGPVSFPLAPGPHFGTPGYGSPHFTALYSSVPFPEGEAFPPVSVTTLGSPMHSN",
                        pdb_id: "6T90",
                        pdb_chain: "K",
                        pdb_seq: "DIKALQKELEQFAKLLKQKRITLGYTQADVGLTLGVLFGKVFSQTTICRFEALQLSFKNMCKLRPLLQKWVEE",
                        pdb_start: 137,
                        score: [],
                        pdb_url: "https://files.rcsb.org/download/6T90.pdb.gz",
                    });
                }
            },
            getProteinAccession(val) {
                this.accession = val;
                if (this.source_db === "AlphaFold") {
                    this.proteinAccession = val;
                    let url = `${this.website}/api/protein_info/${val}/`;
                    // console.log(url)
                    axios.get(url).then((res) => {
                        let info = res.data.results[0];
                        // console.log("info >>> ", info)
                        let pdb_url = info["pdb_url"].replace(
                            /https:\/\/alphafold.ebi.ac.uk\/files/,
                            global_.source
                        );
                        pdb_url
                        this.$store.commit("currentProteinMutation", {
                            source_db: this.source_db,
                            accession: val,
                            description: info["description"],
                            info: info["sequence"],
                            natural: info["sequence"],
                            natural_seq: info["sequence"],
                            score: info["score"],
                            pdb_url: pdb_url,
                        });

                    });
                } else {
                    "2KT0;4RBO;"
                }
            },
            getAlignAccession(val) {
                this.accession = val;
                // console.log(val);
            },
            heightChange(movement) {
                this.structrueHeight -= movement;
                this.$store.commit("structureResizeMutation", this.structrueHeight);
            },
            getLeftWidthChange(movement) {
                this.leftWidth -= movement;
                this.yhandleWidth += movement;
                this.$store.commit("structureResizeMutation", this.leftWidth);
                let sequence_menu = this.$store.state.sequence_menu;
                sequence_menu["leftWidth"] = this.leftWidth;
                this.$store.commit("sequenceMenuMutation", sequence_menu);
            },
            getRightWidthChange(movement) {
                this.rightWidth += movement;
                this.$store.commit("structureResizeMutation", this.rightWidth);
            },
        },
    };
</script>

<style>
    .baimo-scrollbar .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .information .el-tabs--border-card>.el-tabs__content {
        padding: 0px !important;
    }

    .sss {
        display: flex;
    }

    .el-tabs--border-card {
        border: none !important;
        box-shadow: none !important;
    }

    /*.el-select-dropdown__wrap .el-scrollbar__wrap {*/
    /*margin-bottom: 100px !important;*/
    /*}*/
    /*.el-footer {*/
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    /*text-align: center;*/
    /*line-height: 60px;*/
    /*}*/

    .el-footer {
        background-color: #b3c0d1;
        color: #333;
        text-align: center;
        line-height: 20px;
    }
</style>